import { Navigate } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermissions'

type PermissionKey = keyof Omit<ReturnType<typeof usePermissions>, 'isLoading'>

interface Props {
  /** Permission key(s) to check — any one must be true */
  allow: PermissionKey | PermissionKey[]
  children: React.ReactNode
}

/**
 * Route guard that redirects to /dashboard if the user lacks the required permission.
 * Layout already handles the loading state, so we return null while loading.
 */
export default function RequirePermission({ allow, children }: Props) {
  const perms = usePermissions()

  if (perms.isLoading) return null

  const keys = Array.isArray(allow) ? allow : [allow]
  const hasPermission = keys.some(key => perms[key])

  if (!hasPermission) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
